/**
 * @fileoverview gRPC-Web generated client stub for report
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: reports/reports.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var artifact_artifact_pb = require('../artifact/artifact_pb.js')

var chat_chat_pb = require('../chat/chat_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.report = require('./reports_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.report.ReportsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.report.ReportsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.report.ReportsResponse>}
 */
const methodDescriptor_ReportsService_ListReports = new grpc.web.MethodDescriptor(
  '/report.ReportsService/ListReports',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.report.ReportsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.report.ReportsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.report.ReportsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.report.ReportsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.report.ReportsServiceClient.prototype.listReports =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/report.ReportsService/ListReports',
      request,
      metadata || {},
      methodDescriptor_ReportsService_ListReports,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.report.ReportsResponse>}
 *     Promise that resolves to the response
 */
proto.report.ReportsServicePromiseClient.prototype.listReports =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/report.ReportsService/ListReports',
      request,
      metadata || {},
      methodDescriptor_ReportsService_ListReports);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.report.GetReportRequest,
 *   !proto.report.Report>}
 */
const methodDescriptor_ReportsService_GetReport = new grpc.web.MethodDescriptor(
  '/report.ReportsService/GetReport',
  grpc.web.MethodType.UNARY,
  proto.report.GetReportRequest,
  proto.report.Report,
  /**
   * @param {!proto.report.GetReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.report.Report.deserializeBinary
);


/**
 * @param {!proto.report.GetReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.report.Report)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.report.Report>|undefined}
 *     The XHR Node Readable Stream
 */
proto.report.ReportsServiceClient.prototype.getReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/report.ReportsService/GetReport',
      request,
      metadata || {},
      methodDescriptor_ReportsService_GetReport,
      callback);
};


/**
 * @param {!proto.report.GetReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.report.Report>}
 *     Promise that resolves to the response
 */
proto.report.ReportsServicePromiseClient.prototype.getReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/report.ReportsService/GetReport',
      request,
      metadata || {},
      methodDescriptor_ReportsService_GetReport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.report.ListReportsForContextRequest,
 *   !proto.report.ReportsResponse>}
 */
const methodDescriptor_ReportsService_ListReportsForContext = new grpc.web.MethodDescriptor(
  '/report.ReportsService/ListReportsForContext',
  grpc.web.MethodType.UNARY,
  proto.report.ListReportsForContextRequest,
  proto.report.ReportsResponse,
  /**
   * @param {!proto.report.ListReportsForContextRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.report.ReportsResponse.deserializeBinary
);


/**
 * @param {!proto.report.ListReportsForContextRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.report.ReportsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.report.ReportsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.report.ReportsServiceClient.prototype.listReportsForContext =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/report.ReportsService/ListReportsForContext',
      request,
      metadata || {},
      methodDescriptor_ReportsService_ListReportsForContext,
      callback);
};


/**
 * @param {!proto.report.ListReportsForContextRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.report.ReportsResponse>}
 *     Promise that resolves to the response
 */
proto.report.ReportsServicePromiseClient.prototype.listReportsForContext =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/report.ReportsService/ListReportsForContext',
      request,
      metadata || {},
      methodDescriptor_ReportsService_ListReportsForContext);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.report.ListReportVersionsRequest,
 *   !proto.report.ListReportVersionsResponse>}
 */
const methodDescriptor_ReportsService_ListReportVersions = new grpc.web.MethodDescriptor(
  '/report.ReportsService/ListReportVersions',
  grpc.web.MethodType.UNARY,
  proto.report.ListReportVersionsRequest,
  proto.report.ListReportVersionsResponse,
  /**
   * @param {!proto.report.ListReportVersionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.report.ListReportVersionsResponse.deserializeBinary
);


/**
 * @param {!proto.report.ListReportVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.report.ListReportVersionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.report.ListReportVersionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.report.ReportsServiceClient.prototype.listReportVersions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/report.ReportsService/ListReportVersions',
      request,
      metadata || {},
      methodDescriptor_ReportsService_ListReportVersions,
      callback);
};


/**
 * @param {!proto.report.ListReportVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.report.ListReportVersionsResponse>}
 *     Promise that resolves to the response
 */
proto.report.ReportsServicePromiseClient.prototype.listReportVersions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/report.ReportsService/ListReportVersions',
      request,
      metadata || {},
      methodDescriptor_ReportsService_ListReportVersions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.report.GetReportVersionRequest,
 *   !proto.report.ReportVersion>}
 */
const methodDescriptor_ReportsService_GetReportVersion = new grpc.web.MethodDescriptor(
  '/report.ReportsService/GetReportVersion',
  grpc.web.MethodType.UNARY,
  proto.report.GetReportVersionRequest,
  proto.report.ReportVersion,
  /**
   * @param {!proto.report.GetReportVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.report.ReportVersion.deserializeBinary
);


/**
 * @param {!proto.report.GetReportVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.report.ReportVersion)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.report.ReportVersion>|undefined}
 *     The XHR Node Readable Stream
 */
proto.report.ReportsServiceClient.prototype.getReportVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/report.ReportsService/GetReportVersion',
      request,
      metadata || {},
      methodDescriptor_ReportsService_GetReportVersion,
      callback);
};


/**
 * @param {!proto.report.GetReportVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.report.ReportVersion>}
 *     Promise that resolves to the response
 */
proto.report.ReportsServicePromiseClient.prototype.getReportVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/report.ReportsService/GetReportVersion',
      request,
      metadata || {},
      methodDescriptor_ReportsService_GetReportVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.report.RevertReportRequest,
 *   !proto.report.RevertReportResponse>}
 */
const methodDescriptor_ReportsService_RevertReport = new grpc.web.MethodDescriptor(
  '/report.ReportsService/RevertReport',
  grpc.web.MethodType.UNARY,
  proto.report.RevertReportRequest,
  proto.report.RevertReportResponse,
  /**
   * @param {!proto.report.RevertReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.report.RevertReportResponse.deserializeBinary
);


/**
 * @param {!proto.report.RevertReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.report.RevertReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.report.RevertReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.report.ReportsServiceClient.prototype.revertReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/report.ReportsService/RevertReport',
      request,
      metadata || {},
      methodDescriptor_ReportsService_RevertReport,
      callback);
};


/**
 * @param {!proto.report.RevertReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.report.RevertReportResponse>}
 *     Promise that resolves to the response
 */
proto.report.ReportsServicePromiseClient.prototype.revertReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/report.ReportsService/RevertReport',
      request,
      metadata || {},
      methodDescriptor_ReportsService_RevertReport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.report.PublishReportRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ReportsService_PublishReport = new grpc.web.MethodDescriptor(
  '/report.ReportsService/PublishReport',
  grpc.web.MethodType.UNARY,
  proto.report.PublishReportRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.report.PublishReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.report.PublishReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.report.ReportsServiceClient.prototype.publishReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/report.ReportsService/PublishReport',
      request,
      metadata || {},
      methodDescriptor_ReportsService_PublishReport,
      callback);
};


/**
 * @param {!proto.report.PublishReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.report.ReportsServicePromiseClient.prototype.publishReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/report.ReportsService/PublishReport',
      request,
      metadata || {},
      methodDescriptor_ReportsService_PublishReport);
};


module.exports = proto.report;

